
<template>
  <div>
    <v-select label="Vendedor" 
      :loading="loading.sellers"
      :items="sellers" 
      :readonly="employee_read_only"
      :disabled="employee_read_only"
      item-text="attributes.name" 
      item-value="attributes.id"
      prepend-icon="mdi-account"
      v-model="employee_id"
      :menu-props="{ bottom: true, offsetY: true }"
      :clearable="false"
    ></v-select>
  </div>
</template>

<script>
import Api from '@/api/index';

export default {
  name: 'SelectSeller',
  data() {
    return {
      employee_read_only: true,
      employee_id: null,
      loading: {
        sellers: false,
      },
      sellers: [],
    }
  },
  methods: {
    getData(){
      if(this.isDirector()){
        this.employee_read_only = false
      }else if(this.isSeller()){
        this.employee_id = this.current_user_employee_id
      }
      this.getSellers()
    },
    getSellers(){
      this.loading.sellers = true
      this.sellers = []
      let params = {
        short: true,
        by_roles: ["Manager", "Seller"],
      }
      Api.Employee.index(params).then(res => res.data).then(data => {
        this.sellers = data.data
      }).finally(() => {
        this.loading.sellers = false
      })
    },
  },
  watch:{
    employee_id(){
      this.$emit('update', this.employee_id)
    }
  },
  mounted () {
    this.getData()
  },
}
</script>
